import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  private listOfRequestForWhichNoErrorNeedsToBeShown = [
    {
      method: 'GET',
      regex: /dil\/segment\/status\/\w+$/i
    },
    {
      method: 'POST',
      regex: /getsmtapiresponse/
    },
  ];
  private timoutRef: any;
  constructor(private commonNotificationService: CommonNotificationService,
    private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const _this = this;
    const token: string = localStorage.getItem('token');

    if (token) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    }

    if (!request.headers.has('Content-Type')) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }

    if (!request.headers.has('Accept')) {
      request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
    }

    /* Start Loader */
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body && (event.body.is_error || event.body.code)) {
          if (event.body.error_type === 'AUTHENTICATION_FAILED_ERROR') {
            this.authenticationService.logout();
            return;
          }
          // logout in case configured IP address mismatch (for already logged in user, it works only when user switches the network)
          if (event.body.error_type === 'IP_NOT_AUTHORIZED_ERROR') {
            this.commonNotificationService.showSnackBar(`Please log in from the whitelisted IP address`, 'error', 6000);
            clearTimeout(this.timoutRef);
            this.timoutRef = setTimeout(() => this.authenticationService.logout(), 3000);
            return;
          }
          // for query API, don't show any error while retry
          if (event.body.error_type === 'ERROR_RETRY_AFTER_10') {
            return event;
          }
          const filterList = _this.returnTheFilteredList(request);
          if (!filterList.length) {
            const data = {
              url: event.url,
              reason: event.body.error_message || event.body.message,
              status: event.status
            };
            _this.displayError(data);
          }
          return (event);
        }
        /* Stop Loader */
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        const filterList = _this.returnTheFilteredList(request);
        if (filterList.length) {
          return throwError(error);
        }
        if (error.status) {
          let data = {};
          data = {
            url: error.url,
            reason: error && error.error.reason ? error.error.reason : (error.message || error.name),
            status: error.status
          };
          _this.displayError(data);
        }
        return throwError(error);
      }));
  }

  /**
   * we need to check if the request url and method needs to be stopped from alerting error.
   * if the requested url falls in the regex then we do not show alert message.
   */
  returnTheFilteredList(request) {
    return this.listOfRequestForWhichNoErrorNeedsToBeShown.filter(reqObj => {
      return request.method === reqObj.method && reqObj.regex.test(request.url);
    });
  }

  displayError(data: any) {
    if (data && data.url && (data.url.includes("hansel.io") || data.url.includes("netcorecloud"))) {
      this.commonNotificationService.showSnackBar(data.reason, 'error', 5000);
    }
  }
}
